import { D, type CcyCode, type Money } from '@wave/shared';

/**
 * Курс пары в «естественном» направлении: выбираем котировку ≥ 1
 * (103.2986 RUB/GBP вместо 0.0097 GBP/RUB). Считаем из сумм — они точные,
 * в отличие от хранимого курса, округлённого до 4 знаков.
 */
export function naturalRate(
  aAmt: Money,
  aCcy: CcyCode,
  bAmt: Money,
  bCcy: CcyCode,
): { pair: string; value: string } | null {
  const a = D(aAmt || '0');
  const b = D(bAmt || '0');
  if (a.lte(0) || b.lte(0)) return null;
  const ab = a.dividedBy(b); // сколько aCcy за 1 bCcy
  if (ab.gte(1)) return { pair: `${aCcy}/${bCcy}`, value: ab.toDecimalPlaces(4).toString() };
  return { pair: `${bCcy}/${aCcy}`, value: b.dividedBy(a).toDecimalPlaces(4).toString() };
}
